import queryString from 'query-string';

import { QueryStringKeys, UTMSource } from '../../constants';
import { getUtms } from '../getUtms';

/**
 * Creates dynamic direct booking URL that contains proper query parameters and will be passed
 * into Web App iframe
 * @param {Object} utmsOverride - Contains specific UTMs necessary to attribute an owner
 *                                registration with the right method of signup
 * @returns {string}
 */

export const createDirectBookingUrl = (params: {
  walkerProfile: {
    name: string;
    promoCode: string;
    pictureUrl: string;
    servicesLabels: string[];
    uuid: string;
  };
  baseUrl: string;
  query: Record<string, string>;
  utmsOverride: Record<string, string>;
  queryParamsFromServer?: Record<string, string>;
}): string => {
  const {
    query,
    utmsOverride,
    baseUrl,
    queryParamsFromServer,
    walkerProfile: {
      name,
      promoCode,
      pictureUrl,
      servicesLabels,
      uuid,
    },
  } = params;

  const defaultUtms = {
    [QueryStringKeys.UTMSource]: UTMSource.Web,
  };

  // // Get existing UTMs from the URL, and use default UTM values if the URL doesn't contain UTMs
  const utms = getUtms({
    ...queryParamsFromServer,
    ...query,
  }, defaultUtms);

  // Forward other query params other than utms (eg: gclid, adid)
  const nonUtmQueryParams = {
    ...queryParamsFromServer,
    ...query,
  };

  return queryString.stringifyUrl({
    url: baseUrl,
    query: {
      [QueryStringKeys.PromoCode]: promoCode,
      [QueryStringKeys.WalkerName]: name,
      [QueryStringKeys.WalkerImage]: pictureUrl,
      [QueryStringKeys.WalkerServices]: servicesLabels,
      [QueryStringKeys.WalkerUuid]: uuid,
      ...nonUtmQueryParams,
      ...utms,
      ...utmsOverride,
    },
  }, { arrayFormat: 'comma' });
};
